import type { ReactElement } from 'react'

import ObjectiveKeyResultsBlock from './ObjectiveKeyResultsBlock'

import ViewTitle from '~/components/ViewTitle'
import useDocumentTitle from '~/hooks/useDocumentTitle'
import { getQuarter } from '~/utils/home'

import './styles.scss'

const Home = (): ReactElement => {
  useDocumentTitle('Home')

  return (
    <div className="home-view">
      <ViewTitle>{`Q${getQuarter()} Objectives & Key Results (OKR)`}</ViewTitle>
      <ObjectiveKeyResultsBlock />
    </div>
  )
}

export default Home
